/* eslint-disable max-len */
// Dependencies
import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'

// import Helpers from '../Helpers.js'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesProcessOutput from '../styles/ProcessOutput.module.css'
import StepFeed from './StepFeed'
import StepContainer from './StepContainer'
import Helpers from '../Helpers'

// Components

function ProcessOutput({
  task,
  taskFiles = {},
  ...props
}) {
  // const [stepIndex, setStepIndex] = useState(0)
  const [selectedLogKey, setSelectedLogKey] = useState(null)
  const [steps, setSteps] = useState([])
  const [sortedLogs, setSortedLogs] = useState({})
  const [startTime, setStartTime] = useState(Date.now())

  function onClickStep(stepIndex) {
    // setStepIndex(stepIndex)
    setSelectedLogKey(steps[stepIndex]?.id)
  }

  function formatArguments(args) {
    if (typeof args === 'string') {
      return (args && Helpers.isStringJSON(args)) ?
          formatInputUrl(JSON.parse(args)?.['input_url']).filter((url) => url !== undefined) :
          []
    } else if (typeof args === 'object') {
      return formatInputUrl(args['input_url'])
    } else {
      return []
    }
  }

  function formatInputUrl(inputUrl) {
    if (Array.isArray(inputUrl)) {
      return inputUrl
    } else if (typeof inputUrl === 'string') {
      return [inputUrl]
    } else {
      return []
    }
  }

  useEffect(() => {
    const logsObj = task?.logs
    if (logsObj) {
      const isTaskStatusError = task?.status?.toLowerCase() === 'error'
      const tempLogs = Object.keys(logsObj).sort((aKey, bKey) => (logsObj?.[bKey]?.time || Number.MAX_SAFE_INTEGER) - (logsObj?.[aKey]?.time || Number.MAX_SAFE_INTEGER))
      const sortedLogs = {}
      for (let lIndex = 0; lIndex < tempLogs.length; lIndex++) {
        const log = logsObj[tempLogs[lIndex]]
        const logType = log?.type || 'action'
        if (logType === 'action') {
          const numCalls = log?.tool_calls?.length || -1
          for (let tIndex = 0; tIndex < numCalls; tIndex++) {
            const callId = log?.tool_calls?.[tIndex]?.id
            if (!sortedLogs?.[callId]) {
              sortedLogs[callId] = {}
            }
            const newAction = structuredClone(log)
            newAction.tool_calls = [log?.tool_calls?.[tIndex]]
            sortedLogs[callId]['action'] = newAction
          }
        } else if (logType === 'action_output') {
          const callId = log?.tool_call_id
          if (!sortedLogs?.[callId]) {
            sortedLogs[callId] = {}
          }
          sortedLogs[callId]['action-output'] = structuredClone(log)
        } else if (logType === 'summary_output') {
          sortedLogs['summary_output'] = structuredClone(log)
        } else if (logType === 'final_output' || logType === 'final-output') { // final output
          sortedLogs['final-output'] = structuredClone(log)
        }
      }

      const logsNoSummary = {}
      let summaryKey = null
      Object.keys(sortedLogs).forEach((key) => {
        if (sortedLogs[key].type === 'summary_output') {
          summaryKey = key
        } else {
          logsNoSummary[key] = sortedLogs[key]
        }
      })

      const sortedKeys = Object.keys(logsNoSummary).sort((aKey, bKey) => (sortedLogs?.[aKey]?.['action-output']?.time || Number.MAX_SAFE_INTEGER) - (sortedLogs?.[bKey]?.['action-output']?.time || Number.MAX_SAFE_INTEGER))
      if (summaryKey) {
        sortedKeys.push(summaryKey)
      }
      if (selectedLogKey === null) {
        setSelectedLogKey(sortedKeys[0])
      }
      setStartTime(sortedLogs[sortedKeys[0]]?.['action']?.['time'])
      setSteps(
          sortedKeys.map((logKey, lIndex) => {
            if (logKey === 'final-output') {
              const title = 'Final Output'
              const description = sortedLogs?.[logKey]?.['content']
              return {
                'title': title,
                'sources': [],
                'description': description,
                'id': logKey,
              }
            } else if (logKey === 'summary_output') {
              const title = 'Conclusion'
              const description = sortedLogs?.[logKey]?.['content']
              return {
                'title': title,
                'sources': [],
                'description': description,
                'id': logKey,
              }
            }
            const title = Helpers.snakeCaseToDisplay(sortedLogs?.[logKey]?.['action']?.['tool_calls']?.[0]?.['function']?.name || '')
            const args = sortedLogs?.[logKey]?.['action']?.['tool_calls']?.[0]?.['function']?.arguments || '{}'
            const sourceUrls = formatArguments(args)
            const sources = sourceUrls.map((url) => taskFiles[Object.keys(taskFiles).filter((fileKey) => taskFiles[fileKey]?.url === url)?.[0]]?.name).filter((val) => val !== undefined)
            sortedLogs[logKey].sources = sources
            const description = sortedLogs?.[logKey]?.['action']?.['explanation']
            return {
              'title': title,
              'sources': sources,
              'description': description,
              'id': logKey,
              'isLoading': (sortedLogs?.[logKey]?.['action'] && !sortedLogs?.[logKey]?.['action-output'] && !isTaskStatusError),
              'isError': (sortedLogs?.[logKey]?.['action'] && !sortedLogs?.[logKey]?.['action-output'] && isTaskStatusError),
            }
          }),
      )
      setSortedLogs(sortedLogs)
    }
  }, [task])

  // const steps = [
  //   {
  //     title: 'View Package',
  //     sources: ['a.png', 'b.txt', 'b.txt', 'b.txt', 'c.mov', 'c.mov', 'c.mov', 'c.mov'],
  //     description: 'This package contains a folder of vehicle images, two PDF documents, an audio file, and a video file.',
  //   },
  //   {
  //     title: 'Analyze Video',
  //     sources: ['c.mov'],
  //     description: 'The video shows a 2002 Toyota Avalon crashing and an individual fleeing the scene. A policy officer arrives shortly after. The car is extensively damaged, especially on the front and front left side. The car is grey. This information could be relevant to the claim.',
  //   },
  //   {
  //     title: 'Summarize Audio',
  //     sources: ['c.mp3'],
  //     description: 'The audio file is a call between John and State Farm, reporting a car accident involving his stolen Toyota Avalon. The car was stolen outside his auto body shop and later crashed, with the incident being captured on a home surveillance camera. The car has been recovered, but it’s too damaged for repairs. John also mentioned the potential loss of some tools from the car. The claim number is CLM 7890123. This information aligns with the video. ',
  //   },
  //   {
  //     title: 'Analyze Documents',
  //     sources: ['a.pdf', 'b.txt'],
  //     description: 'Next, I should examine the PDF documents.',
  //   },
  // ]

  return (
    <div
      className={stylesProcessOutput['process-output']}
    >
      <StepFeed
        topText={task?.prompt || ''}
        steps={steps}
        onClickStep={onClickStep}
        backgroundColor={props.stepBackgroundColor || '#000'}
      />
      {sortedLogs?.[selectedLogKey] && <StepContainer
        // title={steps?.[stepIndex] ? `STEP ${stepIndex + 1} | ${steps?.[stepIndex]?.title}`: null}
        title={sortedLogs?.[selectedLogKey]?.['action']?.['explanation']}
        step={sortedLogs?.[selectedLogKey]}
        logKey={selectedLogKey}
        isFinal={selectedLogKey === 'final-output'}
        isSummary={selectedLogKey === 'summary_output'}
        taskFiles={taskFiles}
        key={selectedLogKey}
        startTime={startTime}
        isStepError={sortedLogs?.[selectedLogKey]?.['action'] &&
          !sortedLogs?.[selectedLogKey]?.['action-output'] &&
          task?.status?.toLowerCase() === 'error'}
      />}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  taskId: state.userReducer.taskId,
})

export default connect(
    mapStateToProps,
    {},
)(ProcessOutput)
